import { render, staticRenderFns } from "./dishType.vue?vue&type=template&id=33174168&scoped=true"
import script from "./dishType.vue?vue&type=script&lang=js"
export * from "./dishType.vue?vue&type=script&lang=js"
import style0 from "./dishType.vue?vue&type=style&index=0&id=33174168&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33174168",
  null
  
)

export default component.exports